import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'

export default function CampaignPlan() {
    const [data, setData] = useState([])
    // const [documentNo, setDocumentNo] = useState('')
    // const [page, setPage] = React.useState(1);
    const [searchParams, setSearchParams] = useSearchParams()
    let documentNo = searchParams.get('documentNo') || ''
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`plan/inspections?q=${documentNo}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [documentNo])
    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-8 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการใบตรวจการปฏิบัติงาน
                        </label>
                    </div>

                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={documentNo} onChange={e => setSearchParams({ page: page, documentNo: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>

                    </div>
                </div>

                <div class="listData row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                    <th class="text-center">เลขที่คำสั่งกรมการข้าว</th>
                                    <th class="text-center">โครงการ</th>
                                    <th class="text-center">วันที่ทำรายการ</th>
                                    <th class="text-center">วันที่ (คำสั่ง)</th>
                                    <th class="text-center">ดำเนินการ</th>
                                </tr>
                            </thead>
                            <tbody class="cp">
                                {data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                    <tr className={id === encodeURIComponent(x?.InspectionDocNo + x?.BranchNo) ? 'active' : ''}>
                                        <td class="text-center">{x?.BranchName}</td>
                                        <td class="text-center">{x?.InspectionDocNo}</td>
                                        <td class="text-center">{x?.CampaignName}</td>
                                        <td class="text-center">{dayjs(x?.DoiDocDate).format("DD/MM/BBBB")}</td>
                                        <td class="text-center">{dayjs(x?.InspectionDocDate).format("DD/MM/BBBB")}</td>
                                        <td class="text-center">
                                            <Link to={`/sale/campaign-plan/${encodeURIComponent(x?.InspectionDocNo)}?CampaignName=${x?.CampaignName}&BranchNo=${x?.BranchNo}`}  onClick={() => setSearchParams({ id: encodeURIComponent(x?.InspectionDocNo + x?.BranchNo), page: page, documentNo: documentNo,  })}>
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, documentNo: documentNo, id: id })} shape="rounded" />

                    </div>
                </div>
            </div>
        </Page>
    )
}
